import {
  _setTimeBlockV2PreviousKey,
  _setTimeBlockV2PaginationKey,
  _setTimeBlockV2PaginationData,
} from './manageTimeBlockV2Action';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  timeblockV2PreviousKey: '',
  timeBlockV2PaginationKey: '',
  timeBlockV2PaginationData: [],
};

export const timeBlocksV2PaginationDataSlice = createSlice({
  name: 'Time Block V2',
  initialState,
  reducers: {
    resetTimeBlockV2PaginationData: () => initialState,
    setTimeBlockV2PreviousKey: _setTimeBlockV2PreviousKey,
    setTimeBlockV2PaginationKey: _setTimeBlockV2PaginationKey,
    setTimeBlockV2PaginationData: _setTimeBlockV2PaginationData,
  },
});

export const {
  setTimeBlockV2PreviousKey,
  setTimeBlockV2PaginationKey,
  setTimeBlockV2PaginationData,
  resetTimeBlockV2PaginationData,
} = timeBlocksV2PaginationDataSlice.actions;

export default timeBlocksV2PaginationDataSlice.reducer;
